import { observer } from 'mobx-react';
import { FormStore, Input } from 'Mri.Web.Common';
import * as React from 'react';
import { FormGroup } from 'reactstrap';

export interface IDisplayFormDetailsProps {
    readonly displayForm: FormStore<Mri.Web.Internal.Controllers.Displays.UpdateDisplayModel>;
}

@observer
export class DisplayFormDetails extends React.Component<IDisplayFormDetailsProps> {
    public render() {
        const dcdFields = this.props.displayForm.fields.displayConnectionData.fields;
        const ulFields = this.props.displayForm.fields.unitLocation.fields;
        return (
            <>
                <div className="col-12">
                    <h3>Details</h3>
                </div>

                <div className="col-md-6">
                    <FormGroup color={dcdFields.customerDisplayID.state}>
                        <label className="control-label">Display ID</label>

                        <div>
                            <Input
                                type="text"
                                max={50}
                                field={dcdFields.customerDisplayID}
                                placeholder="Customer Identifier"
                            />
                        </div>
                    </FormGroup>

                    <FormGroup color={dcdFields.customerDisplayID2.state}>
                        <label className="control-label">Display ID 2</label>

                        <div>
                            <Input
                                type="text"
                                max={50}
                                field={dcdFields.customerDisplayID2}
                                placeholder="Alternate Display ID"
                            />
                        </div>
                    </FormGroup>

                    <FormGroup color={dcdFields.comments.state}>
                        <label className="control-label">Comment</label>
                        <div>
                            <Input type="text" field={dcdFields.comments} placeholder="Concerns?" />
                        </div>
                    </FormGroup>
                </div>

                <div className="col-md-6">
                    <FormGroup color={ulFields.customerSiteID.state}>
                        <label className="control-label">Site ID</label>
                        <div>
                            <Input
                                type="text"
                                max={50}
                                field={ulFields.customerSiteID}
                                placeholder="Customer Unit/Location identifier"
                            />
                        </div>
                    </FormGroup>

                    <FormGroup color={ulFields.customerSiteID2.state}>
                        <label className="control-label">Site ID 2</label>

                        <div>
                            <Input
                                type="text"
                                max={50}
                                field={ulFields.customerSiteID2}
                                placeholder="Alternate Display ID"
                            />
                        </div>
                    </FormGroup>
                </div>
            </>
        );
    }
}
